import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AnimatedStats from "./sections/AnimatedStats";
import OurServicesSnapshot from "./sections/OurServicesSnapshot";
import TheNethillMethod from "./sections/TheNethillMethod";
import LatestInsights from "./sections/LatestInsights";
import CaseStudyHighlights from "./sections/CaseStudyHighlights";
import GetStarted from "./sections/GetStarted";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AnimatedStats />
      <OurServicesSnapshot />
      <TheNethillMethod />
      <LatestInsights />
      <CaseStudyHighlights />
      <GetStarted />
      <Footer />
    </div>;
}